import React, { ReactElement } from 'react';
import { Entity } from '../../types/entities/Entity';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { formatNumber } from '../../reducer/actions/formatNumber';

type Props<T extends Entity> = {
  values: any;
  onChange: (value: any, column: string) => void;
};

export const GroupFinanceRow = <T extends Entity>({
  values,
  onChange,
}: Props<T>): ReactElement => {
  return (
    <>
      <TableRow>
        <TableCell>{values?.name}</TableCell>
        <TableCell>{values?.service_package}</TableCell>
        <TableCell>{values?.service}</TableCell>
        <TableCell sx={{ textAlign: 'right' }}>
          {values?.size ? formatNumber(values.size) : '-'}
        </TableCell>
        <TableCell sx={{ textAlign: 'right' }}>
          {values?.price_pp ? formatNumber(values.price_pp) : '-'}
        </TableCell>
        <TableCell sx={{ textAlign: 'right' }}>
          {values?.price ? formatNumber(values.price) : '-'}
        </TableCell>
      </TableRow>
    </>
  );
};
